export function validatePnr(personalNumber: string): boolean {
    const value = personalNumber;

    const personalNumberRegEx = /^(19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[-+]?\d{4}$/;

    if (!personalNumberRegEx.test(personalNumber)) {
        return false;
    }

    if (!isValidLuhn(value)) {
        return false;
    }

    return true;
}

function isValidLuhn(personalNumber: string): boolean {
    const digits = personalNumber.replace(/[-+]/g, "").slice(-10);

    const numberArray = digits.split("").map(Number);

    let sum = 0;
    for (let i = 0; i < numberArray.length - 1; i++) {
        let number = numberArray[i];
        if (i % 2 === 0) {
            number *= 2;
            if (number > 9) {
                number -= 9;
            }
        }
        sum += number;
    }

    const control = numberArray[numberArray.length - 1];
    return (sum + control) % 10 === 0;
}
